const platformNames = {
    web: 'Web',
    ios: 'iOS',
    android: 'Android',
};

export default platformNames;